<template>
    <iframe
        class="mediaclip-designer"
        name="mediaclip-designer"
        :src="mediaclipUrl"
    ></iframe>
</template>

<script>
export default {
    name: "GalleryProject",

    data() {
        return {
            mediaclipUrl: null
        };
    },

    mounted() {
        // exit link per mediaclip
        window.mediaclipExitLink = this.$router.resolve({
            name: "gallery-dashboard",
            params: { galleryUrl: this.$route.params.galleryUrl }
        }).href;

        this.$api
            .getOpenProjectUrl(this.$route.params.projectId)
            .then((response) => {
                console.debug("GET_OPEN_PROJECT_URL", response);
                console.debug("URL:", response.url);
                var location = window.location;
                if (location.hostname === "localhost") {
                    alert(
                        "Caricamento Mediaclip non funziona in locale per problemi di CORS"
                    );
                    this.$router.push({ name: "gallery-dashboard" });
                } else {
                    this.mediaclipUrl =
                        response.url +
                        "&data-addToCartUrl=" +
                        this.$router.resolve({ name: "gallery-cart" }).href;
                }
            })
            .catch((error) => {
                console.error("GET_OPEN_PROJECT_URL", error);
            });
    }
};
</script>

<style scoped>
iframe.mediaclip-designer {
    border: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
}
</style>
